/**
 * PayrollPage — Tab wrapper para Nómina/RRHH con ayuda contextual.
 */
import { Outlet, useLocation } from 'react-router-dom'
import { PageHeader } from '@/components/HelpPanel'
import { HELP } from '@/data/helpContent'

const PAGE_META: Record<string, { title: string; subtitle: string; helpKey: string }> = {
  employees:    { title: 'Empleados', subtitle: 'Gestión de empleados y datos personales.', helpKey: 'payroll.employees' },
  contracts:    { title: 'Contratos', subtitle: 'Contratos de trabajo activos e históricos.', helpKey: 'payroll.contracts' },
  documents:    { title: 'Documentos', subtitle: 'Plantillas para generar un documento a varias personas a la vez, con su firma.', helpKey: 'payroll.documents' },
  'org-chart':  { title: 'Organigrama', subtitle: 'Jefaturas y unidades de la empresa, con su historial.', helpKey: 'payroll.org_chart' },
  periods:      { title: 'Períodos de Nómina', subtitle: 'Cálculo, aprobación y pago de nómina mensual.', helpKey: 'payroll.periods' },
  payslips:     { title: 'Liquidaciones', subtitle: 'Liquidaciones de sueldo individuales.', helpKey: 'payroll.payslips' },
  vacations:    { title: 'Vacaciones', subtitle: 'Solicitudes de vacaciones y saldos.', helpKey: 'payroll.vacations' },
  terminations: { title: 'Finiquitos', subtitle: 'Cálculo de finiquitos y desvinculaciones.', helpKey: 'payroll.terminations' },
  bonuses:      { title: 'Bonos', subtitle: 'Configuración de bonos y asignaciones.', helpKey: 'payroll.bonuses' },
  deductions:   { title: 'Descuentos y Créditos', subtitle: 'Descuentos voluntarios y créditos/préstamos al trabajador.', helpKey: 'payroll.deductions' },
  indicators:   { title: 'Indicadores', subtitle: 'UF, UTM, IMM y topes previsionales.', helpKey: 'payroll.indicators' },
  declarations: { title: 'Declaraciones Juradas', subtitle: 'DJ 1887, DJ 1943 y Libro de Remuneraciones.', helpKey: 'payroll.declarations' },
  honorarios:   { title: 'Honorarios (BHE)', subtitle: 'Boletas de honorarios recibidas — retención 2da categoría para F29.', helpKey: 'payroll.honorarios' },
  assets:       { title: 'Activos', subtitle: 'Bienes de la empresa entregados a cada trabajador.', helpKey: 'payroll.assets' },
  settings:     { title: 'Configuración de Nómina', subtitle: 'Recordatorios y parámetros del módulo.', helpKey: 'payroll.settings' },
}

export default function PayrollPage() {
  const { pathname } = useLocation()
  // `/payroll/<sección>/…`: las sub-pantallas de Documentos (editor, envío)
  // conservan el encabezado de su sección en vez de caer al de Empleados.
  const segment = pathname.split('/')[2] || 'employees'
  const meta = PAGE_META[segment] || PAGE_META.employees

  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto">
      <PageHeader title={meta.title} subtitle={meta.subtitle} help={HELP[meta.helpKey]} />
      <Outlet />
    </div>
  )
}
